import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import showObject from '../../utils/showObject';
import imageModifier from '../../utils/imageModifier';

const GalleryObject = (props) => {
  const {
    assetSlugName, fileReadableName, isPublic, fileExtension, cursor, className, url, setObjects, gallerySave, selectedObjects, selected,
  } = props;
  const [objectUrl, setObjectUrl] = useState();
  const [objectType, setObjectType] = useState();
  const [active, setActive] = useState(false);

  const checkFileType = (ext) => {
    switch (ext && ext.toLowerCase()) {
      case 'jpg':
      case 'gif':
      case 'bmp':
      case 'png':
        setObjectType('image');
        break;
      case 'm4v':
      case 'avi':
      case 'mpg':
      case 'mp4':
        setObjectType('video');
        break;
      case 'mp3':
        setObjectType('audio');
        break;
      default:
        setObjectType('file');
    }
  };

  useEffect(() => {
    checkFileType(fileExtension);
    if (!isPublic) {
      showObject(`${assetSlugName}`, fileExtension, true).then((res) => {
        setObjectUrl(res);
      });
    } else {
      setObjectUrl(url);
    }

    if (selectedObjects) {
      if (selectedObjects.findIndex(obj => obj.assetSlugName === assetSlugName) !== -1) setActive(true);
    }
  }, [assetSlugName]);

  useEffect(() => {
    setActive(selected);
  }, [selected]);

  return (
    <div
      className={`${active ? 'justify-center flex flex-col border-5 border-green-pin relative h-125px w-125px m-px' : 'h-125px w-125px text-center items-center justify-center flex flex-col'} 
                  ${cursor && 'pointer-events-none cursor-default'}
                  ${className && `${className}`}`}
      onClick={() => {
        setObjects({
          ...props,
        });
        setActive(!active);
      }}
    >
      {objectType === 'image' && (
        <div className={`${className ? `${className}` : 'bg-cover h-115px w-115px relative flex flex-col justify-center'}`}>
          <img src={imageModifier(objectUrl, '200x200')} className={`${className && `${className}`} 'object-cover'`} alt={fileReadableName && fileReadableName.en} />
        </div>
      )}
      {objectType === 'video' && (
        <>
          <div className="flex-1 flex flex-col h-115px w-115px justify-end">
            <span className={`font-icon icon-video-file flex justify-center ${gallerySave ? 'text-80' : 'text-4xl'}`} />
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">{!gallerySave && <p className="text-10 break-all px-1 m-0 text-justify self-center">{fileReadableName && fileReadableName.en}</p>}</div>
        </>
      )}
      {objectType === 'audio' && (
        <>
          <div className="flex-1 flex flex-col justify-end h-115px w-115px">
            <span className="font-icon icon-music-file text-4xl flex justify-center" />
          </div>
          <div className="flex-1 flex flex-col justify-center">{!gallerySave && <p className="text-10 break-all px-1 m-0 text-justify">{fileReadableName && fileReadableName.en}</p>}</div>
        </>
      )}
      {objectType === 'file' && (
        <>
          <div className="flex-1 flex flex-col justify-end h-115px w-115px">
            <span className="font-icon icon-file text-4xl flex justify-center" />
          </div>
          <div className="flex-1 flex flex-col self-center justify-center text-center">{!gallerySave && <p className="text-10 break-all px-1 m-0 text-justify">{fileReadableName && fileReadableName.en}</p>}</div>
        </>
      )}
      {active && <span className="font-icon icon-pin bg-green-pin text-white text-xl font-bold p-2 pt-1 right-0 top-0 absolute " />}
    </div>
  );
};

GalleryObject.propTypes = {
  assetSlugName: PropTypes.string.isRequired,
  fileExtension: PropTypes.string.isRequired,
  isPublic: PropTypes.bool.isRequired,
  fileReadableName: PropTypes.shape({}).isRequired,
  cursor: PropTypes.bool,
  className: PropTypes.string,
  gallerySave: PropTypes.bool,
  selected: PropTypes.bool,
};

GalleryObject.defaultProps = {
  cursor: false,
  className: '',
  gallerySave: false,
  selected: false,
};

export default GalleryObject;
